import React, { useState } from "react";
import EachDay from "./EachDay";
import AddDayForm from "./AddDayForm";

function HoursOfOperationForm({ hof, updateHours, cancelEditing }) {
    const [addHour, setAddHour] = useState(false);

    return (
        <div className="card card-border shadow-none card-padding">
            <div className="d-flex justify-content-between align-items-center">
                <div>
                    <div className="card-title mb-0 d-flex align-items-center">
                        <i className="bi bi-pencil-square text-primary me-2"></i>
                        Edit Hours of Operation
                    </div>
                    <p className="text-muted small mb-0">Update your clinic's operating hours</p>
                </div>
                <button
                    className="btn btn-outline-secondary btn-sm"
                    onClick={cancelEditing}
                >
                    <i className="bi bi-chevron-left me-1"></i> Back to View
                </button>
            </div>
            <hr/>
            <div className="card-body">
                {/* Table headers */}
                <div className="row mb-3 fw-semibold text-muted small px-3">
                    <div className="col-lg-2 col-md-2 text-center">Day</div>
                    <div className="col-lg-3 col-md-3">Operating Hours</div>
                    <div className="col-lg-2 col-md-2">Status</div>
                    <div className="col-lg-4 col-md-4">Notes</div>
                    <div className="col-lg-1 col-md-1 text-center">Actions</div>
                </div>

                <div className="border-top mb-3"></div>

                {/* Days list */}
                <div className="days-container">
                    {hof && hof.map((item, index) => (
                        <EachDay
                            day={item}
                            hof={hof}
                            key={index}
                            updateHours={updateHours}
                        />
                    ))}
                </div>

            </div>
        </div>
    );
}

export default HoursOfOperationForm;